import { render, staticRenderFns } from "./EventManagementItem.vue?vue&type=template&id=5490417f&scoped=true&"
import script from "./EventManagementItem.vue?vue&type=script&lang=js&"
export * from "./EventManagementItem.vue?vue&type=script&lang=js&"
import style0 from "./EventManagementItem.vue?vue&type=style&index=0&id=5490417f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490417f",
  null
  
)

export default component.exports